import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { getSteemActivePrizeRank, getSbiBalance } from "../../apis/services/steemActivity";
import { extractLoginData } from "../../unit/UserUtil";
export default {
  name: "social-traffic-table",
  data: function data() {
    return {
      tableData: null,
      sbiInfo: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getSteemActivePrizeRank();

            case 2:
              _this.tableData = _context.sent.data;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};